import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationtaxiserviceinmumbai() {



    const cardData = {





keyword: "Outstation Taxi Service in Mumbai",

headingDescription: "Shreesha Tours & Travels provides reliable and affordable Outstation Taxi Service in Mumbai for one-way trips, round-trip journeys, family vacations, corporate travel, pilgrimage tours, weekend getaways, destination weddings, sightseeing tours, and long-distance road travel across Maharashtra and nearby states. We offer a wide range of chauffeur-driven vehicles including Sedan, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury cars to match every travel requirement. Our outstation taxi services are designed with comfortable rides, professional drivers, well-maintained vehicles, transparent pricing, flexible booking options, doorstep pickup, and 24/7 customer support. Whether you are planning a short trip from Mumbai to nearby destinations or a multi-day Maharashtra tour, Shreesha Tours & Travels ensures safe, punctual, and hassle-free transportation. From hill stations and Konkan beaches to religious destinations and heritage locations, we provide dependable cab services to explore Maharashtra with complete comfort.",

topPlaces: [
  {
    title: "Mumbai to Panchgani",
    description: "Panchgani is a beautiful hill station famous for Table Land, Sydney Point, Parsi Point, strawberry farms, and scenic valleys. It is a perfect destination for family vacations and peaceful weekend trips."
  },
  {
    title: "Mumbai to Lavasa",
    description: "Lavasa is a planned hill city known for lakeside views, colorful streets, adventure activities, and pleasant weather. It is an ideal getaway for couples, families, and corporate outings."
  },
  {
    title: "Mumbai to Harihareshwar",
    description: "Harihareshwar is a peaceful coastal destination known for ancient temples, beaches, and beautiful Konkan landscapes. It is popular among pilgrims and beach lovers."
  },
  {
    title: "Mumbai to Murud Janjira",
    description: "Murud Janjira is famous for its historic sea fort, beaches, and scenic coastal beauty. It is a great destination for history enthusiasts and family travelers."
  },
  {
    title: "Mumbai to Malshej Ghat",
    description: "Malshej Ghat is known for waterfalls, mountain views, trekking routes, and beautiful monsoon landscapes. It is one of the best nature destinations near Mumbai."
  },
  {
    title: "Mumbai to Satara",
    description: "Satara is famous for Kaas Plateau, Thoseghar Waterfall, Ajinkyatara Fort, and beautiful Sahyadri landscapes. It is a preferred destination for nature and heritage tours."
  },
  {
    title: "Mumbai to Kolhapur",
    description: "Kolhapur is known for Mahalaxmi Temple, Panhala Fort, Rankala Lake, and traditional Maharashtrian culture. It is a popular destination for religious and family travel."
  },
  {
    title: "Mumbai to Aurangabad",
    description: "Aurangabad is famous for Ajanta and Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and rich historical attractions. It is a preferred destination for heritage tours."
  },
  {
    title: "Mumbai to Nagpur",
    description: "Nagpur is known as the Orange City and famous for Deekshabhoomi, Futala Lake, wildlife attractions, and business centers. It is a major long-distance travel route from Mumbai."
  },
  {
    title: "Mumbai to Amravati",
    description: "Amravati is an important city in Vidarbha known for Ambadevi Temple, Melghat Tiger Reserve, and nearby natural attractions. It is suitable for business, family, and tourism travel."
  }
],




"services": [
  {
    "name": "Outstation Taxi Service in Mumbai",
    "description": "Book Outstation Taxi Service in Mumbai for safe, comfortable, and reliable long-distance travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cabs for family trips, business journeys, holiday tours, pilgrimage travel, and interstate transportation with flexible one way and round trip options."
  },
  {
    "name": "Mumbai Outstation Cab Service",
    "description": "Choose Mumbai Outstation Cab Service for hassle-free travel across Maharashtra and India with experienced drivers, clean vehicles, and affordable pricing. Enjoy convenient doorstep pickup, comfortable seating, transparent fares, and reliable cab solutions for personal, corporate, and family outstation journeys."
  },
  {
    "name": "Mumbai Outstation Taxi Booking",
    "description": "Complete Mumbai Outstation Taxi Booking with easy reservations, instant confirmation, and multiple vehicle choices. Get reliable chauffeur-driven taxis for weekend trips, long-distance travel, airport transfers, business tours, and family vacations with professional customer support."
  },
  {
    "name": "Best Outstation Taxi Mumbai",
    "description": "Book the Best Outstation Taxi Mumbai for premium travel experience with skilled chauffeurs, well-maintained cars, and competitive fares. Whether you need a one day trip, weekend getaway, religious tour, or interstate journey, enjoy safe and comfortable transportation."
  },
  {
    "name": "Mumbai Long Distance Taxi Service",
    "description": "Hire Mumbai Long Distance Taxi Service for comfortable interstate and intercity travel with reliable vehicles and experienced drivers. Perfect for extended journeys, business travel, family tours, and vacation trips with flexible booking plans and affordable rates."
  },
  {
    "name": "Mumbai One Way Outstation Cab",
    "description": "Book Mumbai One Way Outstation Cab for convenient drop services to multiple destinations without return charges. Enjoy affordable one way travel with professional chauffeurs, clean AC vehicles, and customized pickup and drop locations."
  },
  {
    "name": "Mumbai Round Trip Outstation Taxi",
    "description": "Reserve Mumbai Round Trip Outstation Taxi for return journeys with comfortable vehicles, flexible schedules, and experienced drivers. Ideal for sightseeing tours, family holidays, pilgrimage trips, and business travel requiring reliable round trip transportation."
  },
  {
    "name": "Mumbai Airport Outstation Cab",
    "description": "Choose Mumbai Airport Outstation Cab for smooth airport pickup and drop services to cities across India. Get timely transfers, professional chauffeurs, luggage-friendly vehicles, and comfortable travel from Mumbai Airport to your desired destination."
  },
  {
    "name": "Mumbai Outstation Car Rental",
    "description": "Book Mumbai Outstation Car Rental with driver for convenient and affordable long-distance travel. Select from Sedan, SUV, Innova, Innova Crysta, and premium vehicles according to your family size and travel requirements."
  },
  {
    "name": "Mumbai Private Taxi Service",
    "description": "Hire Mumbai Private Taxi Service for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, flexible routes, and reliable transportation for personal trips, family tours, corporate travel, and special occasions."
  },
  {
    "name": "Mumbai Family Outstation Cab",
    "description": "Book Mumbai Family Outstation Cab for safe and comfortable family journeys with spacious vehicles and experienced drivers. Travel conveniently for vacations, temple visits, sightseeing tours, and weekend trips with complete travel assistance."
  },
  {
    "name": "Mumbai Corporate Outstation Taxi",
    "description": "Choose Mumbai Corporate Outstation Taxi for business travel, employee transportation, client visits, meetings, and corporate tours. Get punctual service, premium vehicles, professional chauffeurs, and reliable travel support for corporate requirements."
  },
  {
    "name": "Affordable Outstation Taxi Mumbai",
    "description": "Find Affordable Outstation Taxi Mumbai services with budget-friendly fares, quality vehicles, and experienced drivers. Enjoy economical one way and round trip travel options without compromising safety, comfort, and service quality."
  },
  {
    "name": "Reliable Outstation Cab Mumbai",
    "description": "Choose Reliable Outstation Cab Mumbai for dependable long-distance transportation with trained chauffeurs, clean AC vehicles, transparent pricing, and 24x7 customer support. Travel comfortably across Maharashtra and India for family trips, business journeys, airport transfers, and holiday tours."
  }
],
"tableData": [
  ["Outstation Taxi Service in Mumbai", "Mumbai Outstation Cab Service"],
  ["Mumbai Outstation Taxi Booking", "Best Outstation Taxi Mumbai"],
  ["Mumbai Long Distance Taxi Service", "Mumbai One Way Outstation Cab"],
  ["Mumbai Round Trip Outstation Taxi", "Mumbai Airport Outstation Cab"],
  ["Mumbai Outstation Car Rental", "Mumbai Private Taxi Service"],
  ["Mumbai Family Outstation Cab", "Mumbai Corporate Outstation Taxi"],
  ["Affordable Outstation Taxi Mumbai", "Reliable Outstation Cab Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Outstation Taxi Service in Mumbai",
    WhyChoosedescription: "Explore destinations beyond Mumbai with Shreesha Travels' trusted outstation taxi services. Whether you are planning a family vacation, business trip, pilgrimage tour, weekend getaway, or long-distance journey, we provide comfortable chauffeur-driven cabs for smooth interstate and intercity travel."
  },
  {
    WhyChooseheading: "Travel Across Maharashtra & Other States",
    WhyChoosedescription: "Our outstation cabs connect Mumbai with popular destinations including Pune, Lonavala, Mahabaleshwar, Nashik, Shirdi, Goa, Kolhapur, Surat, Ahmedabad, Indore, Bengaluru, Jaipur, and many other cities across India."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles for Every Journey",
    WhyChoosedescription: "Choose the right vehicle based on your travel needs with options including Swift Dzire, Sedan, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and Mini Buses."
  },
  {
    WhyChooseheading: "Perfect for Family Trips & Holiday Tours",
    WhyChoosedescription: "Our outstation taxi services are ideal for family vacations, hill station visits, beach holidays, sightseeing tours, religious journeys, and customized road trips with complete travel convenience."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Options",
    WhyChoosedescription: "Select from one-way taxi bookings, return journeys, multi-day packages, airport transfers, and personalized travel plans according to your destination and schedule."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Routes",
    WhyChoosedescription: "Our professional chauffeurs are familiar with highways, tourist routes, and intercity travel requirements, ensuring safe driving, timely service, and a comfortable journey."
  },
  {
    WhyChooseheading: "Comfortable Travel with Well-Maintained Cars",
    WhyChoosedescription: "Every vehicle is regularly serviced, cleaned, air-conditioned, and inspected before trips to provide passengers with a safe and enjoyable outstation travel experience."
  },
  {
    WhyChooseheading: "Book Outstation Cabs with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, easy booking assistance, flexible travel plans, and dependable transportation whenever you need an outstation taxi from Mumbai."
  }
]

};

const faqData = [
  {
    question: "What destinations are covered under Mumbai outstation taxi service?",
    answer: "We provide outstation cab services from Mumbai to destinations across Maharashtra, Gujarat, Goa, Karnataka, Madhya Pradesh, Rajasthan, and other states."
  },
  {
    question: "Can I book a one-way outstation cab from Mumbai?",
    answer: "Yes, one-way taxi services are available for travellers who need convenient transportation without returning to Mumbai on the same booking."
  },
  {
    question: "Which cars are available for outstation travel?",
    answer: "We offer Hatchbacks, Sedan cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and Mini Buses."
  },
  {
    question: "Is an outstation cab suitable for family vacations?",
    answer: "Yes, our spacious vehicles and flexible travel plans make them ideal for family holidays, sightseeing tours, and weekend trips."
  },
  {
    question: "Do you provide cabs for pilgrimage tours from Mumbai?",
    answer: "Yes, we arrange outstation taxis for pilgrimage destinations such as Shirdi, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga routes, and other religious locations."
  },
  {
    question: "Can I hire a cab for multiple days?",
    answer: "Yes, multi-day outstation packages are available for vacations, business tours, road trips, and customized travel plans."
  },
  {
    question: "Do outstation taxi bookings include a driver?",
    answer: "Yes, all our outstation cab services include professional chauffeur assistance for a safe and comfortable journey."
  },
  {
    question: "How is the outstation taxi fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, number of days, route, destination, and selected package."
  },
  {
    question: "Can I customize my outstation travel route?",
    answer: "Yes, you can add sightseeing stops, multiple destinations, overnight stays, and personalized travel requirements."
  },
  {
    question: "How can I book an Outstation Taxi Service in Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger count, and preferred vehicle to receive a customized quotation and quick booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Kulkarni",
    feedback: "The outstation journey was planned perfectly with a comfortable vehicle and professional driver. The entire trip was smooth, safe, and completely stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Shah",
    feedback: "We enjoyed a wonderful family trip with Shreesha Travels. The car was clean, the driver was helpful, and the service quality remained excellent throughout the journey.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Taxi Service in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/outstation-taxi-service-in-mumbai.webp",
  "description":
    "Book Outstation Taxi Service in Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable long-distance cab services. We provide one-way and round-trip outstation taxis with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for family trips, business travel, airport transfers, weekend getaways, and intercity journeys across Maharashtra and India.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/outstation-taxi-service-in-mumbai"
  }
};







    return (
        <div>
<Helmet>
  <title>Outstation Taxi Service in Mumbai | One Way & Round Trip Cabs | +91 8355835813</title>

  <meta
    name="description"
    content="Book Outstation Taxi Service in Mumbai with Shreesha Travels for reliable one-way and round-trip cab services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for long-distance travel, airport transfers, family trips, and business journeys with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Outstation Taxi Service in Mumbai, Mumbai Outstation Cab Service, Mumbai Outstation Taxi Booking, Best Outstation Taxi Mumbai, Mumbai Long Distance Taxi Service, Mumbai One Way Outstation Cab, Mumbai Round Trip Outstation Taxi, Mumbai Airport Outstation Cab, Mumbai Outstation Car Rental, Mumbai Intercity Taxi Service, Affordable Outstation Cab Mumbai, Mumbai Outstation Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/59.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Outstationtaxiserviceinmumbai;